import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Block Document',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Block Document',
        href: '/adm/opr/container/block-document',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_block_doc',
    sortDesc: true,
    fields: [
      {
        key: 'code_block',
        sortable: true,
      },
      {
        key: 'date_block',
        label: 'Tanggal',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'doc_no',
        label: 'Doc number',
      },
      {
        key: 'type_block',
        label: 'Block Container',
      },
      {
        key: 'remark_block',
        label: 'Keterangan',
      },
      {
        key: 'status_block',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      id_container: '',
      remark_block: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBlockDoc(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchBlockDoc(context, params = null) {
    let result = await ApiGetRequest(`opr/block-document`, params);
    return !result.error ? result.data.object : [];
  },

  async getListBlockDoc({ commit, state }) {
    commit('changeBlockDoc', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/block-document`, params);
    commit('changeBlockDoc', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailBlockDoc({ commit, state }, payload = null) {
    commit('changeBlockDoc', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/block-document/${payload.id}`);
    commit('changeBlockDoc', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createBlockDoc({ commit, state, dispatch }) {
    commit('changeBlockDoc', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/block-document`, state.data.form);
    commit('changeBlockDoc', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateBlockDoc({ commit, state, dispatch }, payload = null) {
    commit('changeBlockDoc', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/block-document/${payload.id}`,
      state.data.form
    );

    commit('changeBlockDoc', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteBlockDoc({ commit, dispatch }, payload = null) {
    commit('changeBlockDoc', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/block-document/${payload.id}`);
    commit('changeBlockDoc', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
